export class DataLayerData {
  event: string;
  pagina: DataLayerPaginaData;
}

export class DataLayerPaginaData {
  nomePagina: string;
  templatePagina: string;
  contratos?: DataLayerContratosData;
}

export class DataLayerContratosData {
  statusGeral?: SituacaoContratoDataLayer;
  numeroContrato?: string;
  mercadoria?: string;
  dataVencimento?: string;
  saldo?: number;
  parcelasPagas?: number;
  situacao?: SituacaoContratoDataLayer;
}

export enum SituacaoContratoDataLayer {
  EM_ATRASO = 'em atraso',
  EM_ABERTO = 'em aberto',
  PAGO = 'pago',
}

export interface GAUserDetails {
  user_status_login?: 'logado' | 'deslogado';
  user_type?: 'colaborador' | 'cliente';
}

export interface PageDetails {
  page_name: string;
  page_template: string;
  previous_page?: string;
}

export interface SendPageViewEventData {
  event: 'page_view';
  page: PageDetails
  application?: {
    application_environment: 'producao' | 'homologacao';
  }
  user?: GAUserDetails
}
